
jQuery.noConflict();

jQuery(window).on('load', function() {

	if (jQuery('.UEI_title:hover').length != 0) {
		jQuery( ".UEI_title .details" ).css('display','block');
	}
	
	if (jQuery('.AR_title:hover').length != 0) {
		jQuery( ".AR_title .details" ).css('display','block');
	}

	jQuery(".UEI_title").attr('class', 'UEI_title_js');
	jQuery(".AR_title").attr('class', 'AR_title_js');
	
	
  //UFR / ECOLES / INSTITUTS
  jQuery(".UEI_title_js a").click(function () {
    jQuery('.AR_title_js .details').hide().slideUp();
    jQuery('.UEI_title_js').toggleClass("gray");
    jQuery( ".UEI_title_js > a > i" ).toggleClass("fa-chevron-down");
    jQuery( ".UEI_title_js > a > i" ).toggleClass("fa-chevron-up");
    if (jQuery('.AR_title_js').hasClass('gray')) {
      jQuery( ".AR_title_js" ).toggleClass("gray");
      jQuery( ".AR_title_js  > a > i" ).toggleClass("fa-chevron-up");
      jQuery( ".AR_title_js  > a > i" ).toggleClass("fa-chevron-down");
      jQuery( ".UEI_title_js .details" ).toggle();
      jQuery( ".inactive" ).hide().fadeIn("fast");
    } else {
      jQuery( ".UEI_title_js .details").slideToggle();
    }
  });

  jQuery( ".UEI_close" ).click(function () {
    jQuery( ".UEI_title_js .details" ).slideToggle();
    jQuery( ".UEI_title_js").toggleClass("gray");
    jQuery( ".UEI_title_js > a > i" ).toggleClass("fa-chevron-up");
    jQuery( ".UEI_title_js > a > i" ).toggleClass("fa-chevron-down");
   });

  //ACCES RAPIDES
  jQuery('.AR_title_js a').click(function () {
    jQuery('.UEI_title_js .details').hide().slideUp();
    jQuery('.AR_title_js').toggleClass("gray");
    if (jQuery('.UEI_title_js').hasClass('gray')) {
    }
    jQuery( ".AR_title_js  > a > i" ).toggleClass("fa-chevron-down");
    jQuery( ".AR_title_js  > a > i" ).toggleClass("fa-chevron-up");



    if (jQuery('.UEI_title_js').hasClass('gray')) {
      jQuery('.UEI_title_js').toggleClass("gray");
      jQuery( ".UEI_title_js > a > i" ).toggleClass("fa-chevron-up");
      jQuery( ".UEI_title_js > a > i" ).toggleClass("fa-chevron-down");
      jQuery('.AR_title__js .details').toggle();
      jQuery('.AR_title_js .details').hide().fadeIn("fast");
    } else {
      jQuery('.AR_title_js .details').slideToggle();        
    }
  });

  jQuery('.AR_close').click(function () {
    jQuery('.AR_title_js .details').slideToggle();
    jQuery('.AR_title_js').toggleClass("gray");
    jQuery( ".AR_title_js > a > i" ).toggleClass("fa-chevron-up");
    jQuery( ".AR_title_js > a > i" ).toggleClass("fa-chevron-down");
  });

	jQuery( "#dialog-confirm-owa" ).dialog({
		dialogClass: "popin-owa",
		resizable: false,
		autoOpen: false,
		width: "510",
		modal: true,
		closeOnEscape: true,
		buttons: {
			"Aller sur le webmail": function() {
				jQuery( this ).dialog( "close" );
				jQuery("#webmail").submit();
			}
		}
	 });
	
	jQuery( "#owa" ).click(function() {                
		currentForm = jQuery(this).closest( "form" );
		//var intituleReleve = "EEE";
		//jQuery( "#dialog-confirm p" ).first().text(intituleReleve);
		jQuery( "#dialog-confirm-owa" ).dialog( "open" );
		jQuery( ".ui-widget-overlay" ).addClass( "popin-owa" );	
		return false;
	});

  
  
  
});

